import { render, staticRenderFns } from "./ChangeBestLayer.vue?vue&type=template&id=bcc0b0da&"
import script from "./ChangeBestLayer.vue?vue&type=script&lang=ts&"
export * from "./ChangeBestLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports